<template>
  <div v-if="organization">
    <a @click="$bvModal.show('modal_'+organization._id)">
      <small>{{organization.name}}</small>
    </a>
    <b-modal :id="'modal_'+organization._id" :title="organization.name" ok-title="Fechar" ok-only hide-header>
      <div class="row">
        <div class="col-md-3">
          <img class="img-thumbnail" :src="defaultThumb(organization.images)" :alt="organization.name">
        </div>
        <div class="col-md-9">
          <h5><strong>{{organization.name}}</strong></h5>
          <p>{{organization.history}}</p>
        </div>
      </div>
      <table class="product-info">
        <tbody>
          <tr v-if="organization.phones && organization.phones.length">
            <td>Telefone:</td>
            <th class="text-right">{{organization.phones.join(' / ')}}</th>
          </tr>
          <tr v-if="organization.whatsapp && organization.whatsapp.length && organization.whatsapp[0] != ''">
            <td>WhatsApp:</td>
            <th class="text-right">{{organization.whatsapp.join(' / ')}}</th>
          </tr>
          <tr v-if="organization.email">
            <td>Email:</td>
            <th class="text-right">{{organization.email}}</th>
          </tr>
          <tr v-if="organization.contact_persons && organization.contact_persons.length">
            <td>Contatos:</td>
            <td class="text-right">
              <br>
              <p v-for="(contact, index) in organization.contact_persons" :key="index">
                <small>
                  {{contact.name}} ({{contact.position}})
                  <strong v-if="contact.phones && contact.phones.length">: {{contact.phones.join(' / ')}} </strong>
                </small>
              </p>
            </td>
          </tr>
        </tbody>
      </table>

    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['organization']
};
</script>
<style lang="sass">
.product-info
  width: 100%
</style>
